import { Button, Grid, Typography } from "@mui/material";
import { styled as styling } from "@mui/material/styles";

export const GridContainerStyled = styling(Grid)((props) => ({
  display: "flex",
  padding: "80px 120px",
  flexDirection: "column",
  alignItems: "center",
  gap: "10px",

  [props.theme.breakpoints.down("lg")]: {
    padding: "40px 24px",
  },

  [props.theme.breakpoints.down("tablet")]: {
    padding: "40px 16px",
  },
}));

export const CardListContainer = styling(Grid)((props) => ({
  display: "flex",
  width: "100%",
  maxWidth: "1200px",
  justifyContent: "space-between",
  alignItems: "center",

  [props.theme.breakpoints.down("lg")]: {
    maxWidth: "720px",
    flexDirection: "column-reverse",
    alignItems: "center",
    gap: "24px",
    alignSelf: "stretch",
    margin: "auto",
    textAlign: "center",
  },

  [props.theme.breakpoints.down("tablet")]: {
    textAlign: "left",
  },
}));

export const CardImage = styling("img")((props) => ({
  height: "100%",
  width: "100%",
  flexShrink: "0",
  borderRadius: "8px",
  maxHeight: "100%",
  maxWidth: "500px",
  objectFit: "cover",

  [props.theme.breakpoints.down("lg")]: {
    maxWidth: "500px",
  },

  [props.theme.breakpoints.down("tablet")]: {
    maxWidth: "330px",
  },
}));

export const CardTextContainer = styling(Grid)((props) => ({
  display: "flex",
  alignItems: "flex-start",
  flexDirection: "column",
  gap: "24px",
  maxWidth: "600px",
  overflow: "visible",

  [props.theme.breakpoints.down("lg")]: {
    maxWidth: "750px",
    alignItems: "center",
  },

  [props.theme.breakpoints.down("tablet")]: {},
}));

export const CardText = styling(Typography)((props) => ({
  color: "#261754",
  fontFamily: props.type == "desc" ? "Inter" : "Georgia",
  fontSize: props.type == "desc" ? "20px" : "50px",
  fontStyle: "normal",
  fontWeight: 400,
  lineHeight: props.type == "desc" ? "30px" : "60px",
  alignSelf: "stretch",
  letterSpacing: props.type == "desc" ? "0.03px" : "0.06px",
  width: props.type == "desc" ? "unset" : "750px",

  "& b": {
    fontWeight: 500,
    color: "#512ACC",
  },

  [props.theme.breakpoints.down("lg")]: {
    textAlign: props.type == "desc" ? "center" : "center",
    width: "unset",
  },

  [props.theme.breakpoints.down("tablet")]: {
    fontSize: props.type == "desc" ? "16px" : "24px",
    lineHeight: props.type == "desc" ? "22.4px" : "28.8px",
    letterSpacing: props.type == "desc" ? "unset" : "0.036px",
  },
}));

export const ButtonStyled = styling(Button)((props) => ({
  display: "flex",
  height: "56px",
  padding: "0px 40px",
  justifyContent: "center",
  alignItems: "center",
  gap: "10px",
  borderRadius: "8px",
  color: "rgba(0,0,0,0.87)",
  boxShadow: "0px 2px 4px 0px rgba(104, 77, 0, 0.40)",
  textAlign: "center",
  fontFamily: "Inter",
  fontSize: "20px",
  fontWeight: 700,
  fontStyle: "normal",
  lineHeight: "120%",
  textTransform: "capitalize",
  whiteSpace: "nowrap",
  background: "#FFDA07",

  "&:hover": {
    backgroundColor: "#FFDA07",
    boxShadow:
      "0px 2px 4px -1px rgba(0,0,0,0.2),0px 4px 5px 0px rgba(0,0,0,0.14),0px 1px 10px 0px rgba(0,0,0,0.12)",
  },

  [props.theme.breakpoints.down("lg")]: {
    fontSize: "1rem",
    lineHeight: "150%",
    letterSpacing: "0.1px",
  },

  [props.theme.breakpoints.down("tablet")]: {
    maxWidth: "280px",
    paddingInline: "1rem",
    height: "48px",
  },
}));
